import { getApiImplementation } from "../BaseApi";
import { TOKEN_KEY } from "../Constants";

export default class BaseApiRequest {
  getData = () => {
    const accessToken = sessionStorage.getItem(TOKEN_KEY);
    const body = JSON.parse(JSON.stringify(this.getBody()));
    return getApiImplementation()
      .callApi(this.getMethod(), this.getUrl(), body, accessToken)
      .then((response) => {
        if (!response) {
          throw new Error("response undefined");
        }
        return response;
      })
      .catch((error) => {
        throw error;
      });
  };
}
